<template>
  <div class="about_us_page">
    <div class="page_top_img_container life_bk_block">
      <div class="banner_container"><img src="@/assets/images/about/banner.jpg" class="top_banner"></div>
      <div class="page_content_container">
        <div class="title_with_line">
          <div class="title_line"><span>关于智众</span></div>
          <div class="title_e">About Zhizhong</div>
        </div>
        <div class="content_container">
          <div class="mmc_title_with_line margin_top_set">我们的使命</div>
          <div class="text_with_img_show">
            <div class="text_show text_1">
              <div class="text_e">OUR MISSION</div>
              <div class="text_detail">用创新模式造福广大慢病患者</div>
            </div>
            <div class="img_show"><img src="@/assets/images/about/pic1.png" alt=""></div>
          </div>
          <div class="mmc_title_with_line margin_top_set">我们的愿景</div>
          <div class="text_with_img_show">
            <div class="img_show"><img src="@/assets/images/about/pic2.png" alt=""></div>
            <div class="text_show text_2">
              <div class="text_e">OUR VISION</div>
              <div class="text_detail">打造中国最大的慢病管理云平台</div>
            </div>
          </div>
          <div class="mmc_title_with_line margin_top_set">我们的价值观</div>
          <div class="text_with_img_show">
            <div class="text_show text_3">
              <div class="text_e">OUR VALUES</div>
              <div class="text_detail">用户至上：永远把用户价值放在第一位<br>
                协作共赢：集众之智、互相成就<br>
                实事求是：尊重客观事实，绝不弄虚作假<br>
                结果导向：成功是做出多少结果，不是做了多少任务</div>
            </div>
            <div class="img_show"><img src="@/assets/images/about/pic3.png" alt=""></div>
          </div>
          <div class="mmc_title_with_line margin_top_set">荣誉证书</div>
          <div class="text_with_img_show">
            <div class="img_show"><img src="@/assets/images/about/pic4.png" alt=""></div>
            <div class="text_show text_4">
              <div class="text_e">CERTIFICATE OF HONOR</div>
              <div class="text_detail">智众在《国家重点支持的高新技术领域》内，持续进行研究开发与技术成果转化，形成智众核心自主知识产权。在研究开发组织管理水平、科技成果转化能力、自主知识产权数量、销售与总资产成长性等指标上，符合《高新技术企业认定管理工作指引》的要求，于2019年获得国家级高新技术企业认定。该证书由国家高企认定办审批认定后，上海市科学技术委员会、上海市财政局、国家税务总局上海市税务局联合编发。</div>
            </div>
          </div>
          <div class="mmc_title_with_line margin_top_set">联系我们</div>
          <div class="text_with_img_show">
            <div class="text_show text_5">
              <div class="text_e">CONTACT US</div>
              <div class="text_detail">
                电话：021-5856-3033<br>
                地址：上海市浦东新区浦东南路999号9层<br>
                网站负责人邮箱：zhujj@zz-med.com
              </div>
            </div>
            <div class="img_show"><img src="@/assets/images/about/pic5.png" alt=""></div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
@about_color_set:#ec7700;
.about_us_page{
  .banner_container{
    width:100%;
    text-align:right;
    background-image:linear-gradient(to bottom, #f1f4f6,#f6f9fb);
  }
  .content_container{
    padding-bottom: 80px;
    .text_with_img_show{
      width: 100%;
      height: 270px;
      background: #FFFFFF;
      border: 1px solid #D8D8D8;
      box-shadow: 0 7px 15px 0 rgba(0,0,0,0.15);
      overflow: hidden;
      .text_show,.img_show{
        float: left;
      }
      .text_show,.img_show{
        width: 50%;
      }
      .text_show{
        line-height: 22px;
        box-sizing: border-box;
        .text_e{
          font-size: 20px;
          color: @about_color_set;
        }
        .text_detail{
          font-size: 18px;
          color: #333333;
          &::before,&::after{
            font-size: 32px;
            color: @about_color_set;
            margin-top: 20px;
            vertical-align: middle;
          }
          &:before{
            content: "“";
            padding: 0 10px 0 0;
          }
          &:after{
            content: "”";
            padding: 0 0 0 10px;
          }
        }
        &.text_1{
          padding: 40px;
          .text_detail{
            margin-top: 58px;
          }
        }
        &.text_2{
          padding: 46px 0 0 56px;
          .text_detail{
            margin-top: 60px;
          }
        }
        &.text_3{
          padding: 32px 0 63px 44px;
          line-height: 28px;
          position: relative;
          .text_detail{
            font-size: 16px;
            margin-top: 34px;
            &::before,&::after{
              position: absolute;
            }
            &:before{
              top: 75px;
              left: 6px;
            }
            &:after{
              bottom: 60px;
              right: -3px;
            }
          }
        }
        &.text_4{
          padding: 31px;
          line-height: 24px;
          .text_detail{
            font-size: 14px;
            margin-top: 20px;
            &::before,&::after{
              display: none;
            }
          }
        }
        &.text_5{
          padding: 35px 0 88px 39px;
          line-height: 38px;
          position: relative;
          .text_detail{
            margin-top: 34px;
            padding-left: 30px;
            box-sizing: border-box;
            &::before,&::after{
              position: absolute;
            }
            &:before{
              top: 85px;
              left: 30px;
            }
            &:after{
              bottom: 85px;
              right: 40px;
            }
          }
        }
      }
      .img_show{
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .mmc_title_with_line{
      color: #0093dd;
    }
  }
}
@media screen and (max-width: 1000px) and (min-width: 475px){
  .text_with_img_show{
    width: 445px !important;
    height: 540px !important;
    margin: 0 auto;
    .text_show,.img_show{
      height: 270px !important;
      width: 100% !important;
    }
  }
}
@media screen and (max-width: 475px){
  .text_with_img_show{
    width: 100% !important;
    height: 540px !important;
    margin: 0 auto;
    transform: scale(.9);
    .text_show,.img_show{
      height: 270px !important;
      width: 100% !important;
    }
    .text_show{
      .text_detail{
        &::before,&::after{
          display: none !important;
        }
      }
      &.text_2{
        padding: 46px 0 0 36px !important;
      }
      &.text_3{
        padding: 32px 0 0 24px !important;
      }
      &.text_4{
        padding: 10px !important;
      }
      &.text_5{
        padding: 35px 0 0 20px !important;
        .text_detail{
          padding-left: 0 !important;
        }
      }
    }
  }
}
</style>
